<template>
    <v-content
            class="ma-0 pa-0"
    >
        <v-row class="ma-1 pa-0">
            <v-text-field v-model="MonthlyTargetYear" type="number" label="년"/>
            <v-text-field v-model="MonthlyTargetMonth" type="number" label="월"/>
            <v-text-field v-model="MonthlyTargetValue" type="number" label="목표값"/>
            <v-btn color="primary" small class="mt-3" @click="Add">추가 & 수정</v-btn>
        </v-row>
        <span>목표값 목록</span>
        <v-divider/>
        <v-data-table
            :headers="headers"
            :items="DataList"
            :sort-by="['year', 'month']"
            :sort-desc="[true, true]"
            multi-sort
            class="ma-1 pa-0"
        />
    </v-content>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MonthlyTargetValue',
  props: {
    update: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    MonthlyTargetYear: parseInt(moment(new Date()).format('YYYY')),
    MonthlyTargetMonth: parseInt(moment(new Date()).format('MM')),
    MonthlyTargetValue: 0,
    headers: [
      {
        text: '년',
        align: 'center',
        sortable: false,
        value: 'year'
      },
      {
        text: '월',
        align: 'center',
        sortable: false,
        value: 'month'
      },
      {
        text: '목표값',
        align: 'center',
        sortable: false,
        value: 'value'
      }
    ],
    DataList: []
  }),
  methods: {
    Add () {
      let query = '/' + this.code + '/' + this.category + '/' + this.MonthlyTargetYear + '/' + this.MonthlyTargetMonth
      this.$axios.get('/api/monthlytargetvalues' + query, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get monthlytargetvalues -> ' + res)
          this.updateValue()
        })
        .catch((e) => {
          console.log('failed get monthlytargetvalues -> ' + JSON.stringify(e.response.data))
          if(e.response.data.status === 'NOT_FOUND')
            this.appendValue()
        })
    },
    appendValue () {
      let data = {
          id: '',
          code: this.code,
          category: this.category,
          year: parseInt(this.MonthlyTargetYear),
          month: parseInt(this.MonthlyTargetMonth),
          value: this.MonthlyTargetValue
        }

      this.$axios.post('/api/monthlytargetvalues', data, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded post monthlytargetvalues -> ' + res)
          this.$dialog.alert('목표값이 추가 되었습니다.', { okText: '확인' }).then(function (dialog) {
          })
          this.updateData()
        })
        .catch((e) => {
          console.log('failed post monthlytargetvalues -> ' + JSON.stringify(e.response.data))
        })
    },
    updateValue () {
      let data = {
          id: '',
          category: this.category,
          year: parseInt(this.MonthlyTargetYear),
          month: parseInt(this.MonthlyTargetMonth),
          value: this.MonthlyTargetValue,
          code: this.code
        }
      this.$axios.put('/api/monthlytargetvalues', data, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded put monthlytargetvalues -> ' + res)
          this.$dialog.alert('목표값이 수정 되었습니다.', { okText: '확인' }).then(function (dialog) {
          })
          this.updateData()
        })
        .catch((e) => {
          console.log('failed put monthlytargetvalues -> ' + JSON.stringify(e.response.data))
        })
    },
    updateData () {
      let query = '/' + this.code + '/' + this.category
      this.$axios.get('/api/monthlytargetvalues' + query, this.$Common.headerApiRequest())
        .then((res) => {
          console.log('succeeded get monthlytargetvalues -> ' + res)
          this.DataList = []
          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].month < 10) {
                res.data[i].month = '0' + res.data[i].month.toString()
              }
            }
            this.DataList = res.data
          }
        })
        .catch((e) => {
          console.log('failed get monthlytargetvalues -> ' + JSON.stringify(e.response.data))
        })
    }
  },
  watch: {
    update () {
      this.updateData()
    }
  },
  created () {
    this.updateData()
  }
}
</script>

<style scoped>

</style>
